export default {
  EmailTitle: `Para recuperar su contraseña, favor de enviar su correo electrónico.`,
  ResetOptionsTitle: `¿Como le gustaría verificar su cuenta?`,
  SecurityQuestionsTitle: `Por favor responda sus preguntas de seguridad.`,
  ResetTitle: `Por favor ingrese una contraseña nueva.`,
  ResetDescription: `Las contraseñas deben tener al menos quince caracteres.`,
  Success: `¡Éxito!`,
  PasswordHasBeenReset: `Tu contraseña ha sido restablecida.`,
};
